import React from 'react';
import Panel from '../../../../components/outline/Panel';
import BrandTierSelectorHeader from '../BrandTierSelectorHeader';
import BrandTierSelectorList from '../BrandTierSelectorList';
import './BrandTierSelectorSection.scss';

const BrandTierSelectorSection = (props) => {
  const {
    currentTierList,
    brandTierSelector,
    setData,
    searchBrandTierSelectorList,
    resetBrandTierSelectorList,
    addBrandTierListItem,
    checkIsDuplicateOnTierList,
    selectSelectorList,
    checkIsSelectedOnSelector,
    addSelectedItemToList,
  } = props;

  return (
    <Panel className="brand-tier-selector-section">
      {/*브랜드 셀렉터 헤더*/}
      <BrandTierSelectorHeader
        currentTierList={currentTierList}
        brandTierSelector={brandTierSelector}
        setData={setData}
        searchBrandTierSelectorList={searchBrandTierSelectorList}
        resetBrandTierSelectorList={resetBrandTierSelectorList}
        selectSelectorList={selectSelectorList}
        addSelectedItemToList={addSelectedItemToList}
      />

      {/*브랜드 셀렉터 리스트*/}
      <BrandTierSelectorList
        brandTierSelector={{
          list: brandTierSelector.list,
          selectedList: brandTierSelector.selectedList,
          selectedTier: brandTierSelector.selectedTier,
        }}
        setData={setData}
        addBrandTierListItem={addBrandTierListItem}
        checkIsDuplicateOnTierList={checkIsDuplicateOnTierList}
        checkIsSelectedOnSelector={checkIsSelectedOnSelector}
      />
    </Panel>
  );
};

export default BrandTierSelectorSection;
